export default {
  body: "Raleway",
  accent: "Source Serif Pro",
}
